export const FETCH_THERMIT_DEPARTMENT_LIST_BASED_PROJECT_ID_REQUEST = 'FETCH_THERMIT_DEPARTMENT_LIST_BASED_PROJECT_ID_REQUEST'
export const FETCH_THERMIT_DEPARTMENT_LIST_BASED_PROJECT_ID_SUCCESS = 'FETCH_THERMIT_DEPARTMENT_LIST_BASED_PROJECT_ID_SUCCESS'
export const FETCH_THERMIT_DEPARTMENT_LIST_BASED_PROJECT_ID_FALUIRE = 'FETCH_THERMIT_DEPARTMENT_LIST_BASED_PROJECT_ID_FALUIRE'
